import { render, staticRenderFns } from "./setParams.vue?vue&type=template&id=3709847d&scoped=true"
import script from "./setParams.vue?vue&type=script&lang=js"
export * from "./setParams.vue?vue&type=script&lang=js"
import style0 from "./setParams.vue?vue&type=style&index=0&id=3709847d&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3709847d",
  null
  
)

export default component.exports